import { Button, Container, Grid } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { HashLink } from "react-router-hash-link";
import Prantosh from "../../../img/Prantosh.jpeg";

const about = {
  backgroundColor: "#111a28",
  color: "#fff",
  paddingTop: "5%",
};

const resume = {
  textDecoration: "none",
  color: "#fff",
};

const About = () => {
  return (
    <Box id="about" style={about}>
      <Container sx={{ flexGrow: 1 }}>
        <h1 className="pseudo">About Me</h1>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box sx={{ textAlign: "left" }}>
              <p
                style={{
                  lineHeight: "200%",
                  fontSize: "20px",
                  textAlign: "justify",
                }}
              >
                Hello!! I'm Prantosh Bepari, A Junior Full Stack Web Developer &
                passionate about Web Development. I develop Web App, Mobile App
                and Desktop App. My core skill is based on JavaScript and I love
                to do most the things using JavaScript. I love to make the web
                more open to the world. I'm available for any kind of job
                opportunity that suits my interests.
              </p>
              <Button sx={{ mr: 2 }} variant="contained" size="large">
                <a
                  style={resume}
                  rel="noreferrer"
                  target="_blank"
                  href="https://drive.google.com/file/d/1xMiWnwivJjSzciF-9n_z9CcFAQU_13sm/view?usp=sharing"
                >
                  Get Resume
                </a>
              </Button>
              <HashLink
                style={{ textDecoration: "none" }}
                smooth
                to="/home#skill"
              >
                <Button sx={{ color: "white" }} variant="outlined" size="large">
                  My Skill
                </Button>
              </HashLink>
            </Box>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            item
            xs={12}
            md={6}
          >
            <img
              style={{ width: "80%", borderRadius: "10px" }}
              src={Prantosh}
              alt=""
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;
